import { Component, OnInit } from '@angular/core';
import { RecurringPaymentsStoreService } from '@modules/recurring-payments/services/recurring-payments-store.service';
import { UserRecurringPayment } from '@app/modules/recurring-payments/classes/user-recurring-payment';

@Component({
    selector: 'app-recurring-payment-status',
    templateUrl: './recurring-payment-status.component.html',
})
export class RecurringPaymentStatusComponent implements OnInit {
    constructor(private _recurringPaymentStore: RecurringPaymentsStoreService) {}

    currentUserRecurringPayment: UserRecurringPayment;

    ngOnInit() {
        const { userAffiliation } = this._recurringPaymentStore.recurrentPaymentState;
        this.currentUserRecurringPayment = userAffiliation;
    }
}
